import axios from 'axios';
import { request_mutations, request_state } from '../utils/store';
import { SPACE_MEMBERS_LIST, SPACE_MEMBERS_DETAIL } from '../api';
import { auth } from '../utils/requests';

export default {
    namespaced: true,
    state: {
        list: request_state(),
        create: request_state(),
        update: request_state(),
        remove: request_state(),
    },
    mutations: {
        ...request_mutations('space_members_list', 'list'),
        ...request_mutations('create_space_member', 'create'),
        ...request_mutations('update_space_member', 'update'),
        ...request_mutations('remove_space_member', 'remove'),
    },
    actions: {
        list({ commit }, params) {
            commit('space_members_list_loading');
            axios.get(SPACE_MEMBERS_LIST, { params, ...auth() })
                .then(response => commit('space_members_list_success', response.data))
                .catch((error) => {
                    commit('space_members_list_error', error.response ? error.response.data : {});
                });
        },
        create({ commit }, data) {
            commit('create_space_member_loading');
            return new Promise((resolve) => {
                axios.post(SPACE_MEMBERS_LIST, data, auth()).then((response) => {
                    commit('create_space_member_success', response.data);
                    resolve();
                }).catch((error) => {
                    commit('create_space_member_error', error.response ? error.response.data : {});
                });
            });
        },
        update({ commit }, { id, data }) {
            const url = SPACE_MEMBERS_DETAIL.replace('{id}', id);

            commit('update_space_member_loading');
            return new Promise((resolve) => {
                axios.patch(url, data, auth()).then((response) => {
                    commit('update_space_member_success', response.data);
                    resolve();
                }).catch((error) => {
                    commit('update_space_member_error', error.response ? error.response.data : {});
                });
            });
        },
        remove({ commit }, { id }) {
            const url = SPACE_MEMBERS_DETAIL.replace('{id}', id);
            commit('remove_space_member_loading');
            return new Promise((resolve) => {
                axios.delete(url, auth()).then((response) => {
                    commit('remove_space_member_success', response.data);
                    resolve();
                }).catch((error) => {
                    commit('remove_space_member_error', error.response ? error.response.data : {});
                });
            });
        },
    },
};
